import Phaser from 'phaser';
import type { GameController } from '../ui/controller';
import { FieldScene } from './FieldScene';

export function createGame(parent: string, controller: GameController): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    backgroundColor: '#120c16',
    banner: false,
    audio: { noAudio: true },
    scale: {
      mode: Phaser.Scale.RESIZE,
      width: 640,
      height: 520,
    },
    scene: [new FieldScene(controller)],
  });
}
